<div class="p-4">
  <!-- Stats cards -->
  @if (stats) {
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.ASSIGNATIONS_TOTALES' | translate }}</p>
        <p class="stat-value">{{ stats.assignationsTotales }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.CONTENUS_UNIQUES' | translate }}</p>
        <p class="stat-value">{{ stats.contenusUniques }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.COMPLETES' | translate }}</p>
        <p class="stat-value stat-value-green">{{ stats.completes }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.EN_COURS' | translate }}</p>
        <p class="stat-value stat-value-blue">{{ stats.enCours }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.A_REFAIRE' | translate }}</p>
        <p class="stat-value stat-value-orange">{{ stats.aRefaire }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.NON_DEMARRES' | translate }}</p>
        <p class="stat-value">{{ stats.nonDemarres }}</p>
      </div>
      <div class="stat-card">
        <p class="stat-label">{{ 'RAPPORT_PARCOURS.NOTE_MOYENNE' | translate }}</p>
        <p class="stat-value">{{ stats.noteMoyenne != null ? (stats.noteMoyenne | number:'1.0-1') + '%' : '-' }}</p>
      </div>
    </div>
  }

  <!-- Table section -->
  <div class="table-card">
    <div class="flex justify-between items-center mb-4 flex-wrap gap-2">
      <h2 class="text-white font-semibold text-lg">{{ 'RAPPORT_PARCOURS.LISTE_CONTENUS' | translate }}</h2>
      <div class="flex gap-2">
        <button [matMenuTriggerFor]="exportMenu" [disabled]="isLoading || !dataSource.data.length" class="btn-primary-novo">
          {{ 'RAPPORT_PARCOURS.EXPORT' | translate }}
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #exportMenu="matMenu" panelClass="export-menu-styling">
          <button mat-menu-item (click)="exporterExcel()">
            <mat-icon>table_view</mat-icon>
            <span>{{ 'RAPPORT_PARCOURS.EXPORT_EXCEL' | translate }}</span>
          </button>
          <button mat-menu-item (click)="exporterPdf()">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>{{ 'RAPPORT_PARCOURS.EXPORT_PDF' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- Search -->
    <div class="report-filters report-filters-contenus mb-4">
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerRecherche()"
        placeholder="{{ 'RAPPORT_PARCOURS.RECHERCHER_CONTENU' | translate }}" class="rapport-search-input" />
        <mat-select class="filtre-select" [(ngModel)]="filtreOrganisation" (selectionChange)="appliquerFiltres()"
          multiple placeholder="{{ 'RAPPORT_PARCOURS.TOUTES_ORGANISATIONS' | translate }}" panelWidth="280">
          <mat-option>
            <ngx-mat-select-search [formControl]="organisationFilterCtrl"
              [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (organisation of filteredOrganisations | async; track organisation) {
            <mat-option [value]="organisation">{{ organisation }}</mat-option>
          }
        </mat-select>
        <mat-select class="filtre-select" [(ngModel)]="filtreParcours" (selectionChange)="appliquerFiltres()"
          multiple placeholder="{{ 'RAPPORT_PARCOURS.TOUS_LES_PARCOURS' | translate }}" panelWidth="280">
          <mat-option>
            <ngx-mat-select-search [formControl]="parcoursFilterCtrl"
              [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (nomParcours of filteredParcours | async; track nomParcours) {
            <mat-option [value]="nomParcours">{{ nomParcours }}</mat-option>
          }
        </mat-select>
        <mat-select class="filtre-select" [(ngModel)]="filtreUtilisateur" (selectionChange)="appliquerFiltres()"
          multiple placeholder="{{ 'RAPPORT_PARCOURS.TOUS_UTILISATEURS' | translate }}" panelWidth="280">
          <mat-option>
            <ngx-mat-select-search [formControl]="utilisateurFilterCtrl"
              [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (utilisateur of filteredUtilisateurs | async; track utilisateur) {
            <mat-option [value]="utilisateur">{{ utilisateur }}</mat-option>
          }
        </mat-select>
        <mat-select class="filtre-select" [(ngModel)]="filtreEtiquette" (selectionChange)="appliquerFiltres()"
          multiple placeholder="{{ 'RAPPORT_PARCOURS.TOUTES_ETIQUETTES' | translate }}" panelWidth="280">
          <mat-option>
            <ngx-mat-select-search [formControl]="etiquetteFilterCtrl"
              [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (etiquette of filteredEtiquettes | async; track etiquette) {
            <mat-option [value]="etiquette">
              <span class="etiquette-chip" [ngStyle]="obtenirStyleEtiquette(etiquette)">
                {{ etiquette }}
              </span>
            </mat-option>
          }
        </mat-select>
        <mat-select class="filtre-select" [(ngModel)]="filtreStatut" (selectionChange)="appliquerFiltres()"
          multiple placeholder="{{ 'RAPPORT_PARCOURS.TOUS_STATUTS' | translate }}" panelWidth="280">
          <mat-option>
            <ngx-mat-select-search [formControl]="statutFilterCtrl"
              [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (statut of filteredStatuts | async; track statut) {
            <mat-option [value]="statut">{{ 'RAPPORT_PARCOURS.STATUT_' + statut | translate }}</mat-option>
          }
        </mat-select>
        <mat-select class="filtre-select" [(ngModel)]="filtreActifUtilisateur" (selectionChange)="appliquerFiltres()"
          placeholder="{{ 'RAPPORT_PARCOURS.FILTRE_UTILISATEUR_ACTIF' | translate }}" panelWidth="220">
          <mat-option value="actif">{{ 'RAPPORT_PARCOURS.UTILISATEURS_ACTIFS' | translate }}</mat-option>
          <mat-option value="inactif">{{ 'RAPPORT_PARCOURS.UTILISATEURS_INACTIFS' | translate }}</mat-option>
          <mat-option value="tous">{{ 'RAPPORT_PARCOURS.TOUS_LES_UTILISATEURS' | translate }}</mat-option>
        </mat-select>
        <button mat-icon-button type="button" class="rapport-reset-btn" (click)="reinitialiserFiltres()">
          <mat-icon>restore</mat-icon>
        </button>
      </div>

      @if (isLoading) {
        <div class="flex justify-center items-center h-64">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      }

      @if (!isLoading) {
        <div class="rapport-table-scroll">
          <mat-table [dataSource]="dataSource" matSort class="table-vue-contenus">
            <ng-container matColumnDef="nomContenu">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.NOM_CONTENU' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.nomContenu }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="nomUtilisateur">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.NOM_UTILISATEUR' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span>
                  {{ row.nomUtilisateur }}
                  @if (!row.estUtilisateurActif) {
                    <span class="text-gray-400 text-xs ml-1">({{ 'RAPPORT_PARCOURS.UTILISATEUR_INACTIF' | translate }})</span>
                  }
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="etiquettes">
              <mat-header-cell *matHeaderCellDef>{{ 'RAPPORT_PARCOURS.ETIQUETTES' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <div class="etiquettes-cellule" [title]="row.etiquettes?.join(', ')">
                  @for (etiquette of row.etiquettes; track etiquette) {
                    <span class="etiquette-chip"
                    [ngStyle]="obtenirStyleEtiquette(etiquette)">{{ etiquette }}</span>
                  }
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="nomParcours">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.NOM_PARCOURS' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row"><span class="nom-parcours-cellule">{{ row.nomParcours }}</span></mat-cell>
            </ng-container>
            <ng-container matColumnDef="statut">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.STATUT' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span [class]="classeStatut(row.statut)">
                  {{ 'RAPPORT_PARCOURS.STATUT_' + row.statut | translate }}
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dateDerniereCompletion">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.DATE_DERNIERE_COMPLETION' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">
                {{ row.dateDerniereCompletion ? (row.dateDerniereCompletion | dateFormat) : '-' }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="note">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.NOTE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">
                @if (row.note != null && row.statut !== EStatutRapportParcours.ARefaire) {
                  <div class="rapport-progress-container">
                    <div class="rapport-progress-bar progress-green" [style.width.%]="row.note" [class.has-value]="row.note > 0"></div>
                  </div>
                  <span class="ml-2 text-white text-sm">{{ row.note }}%</span>
                } @else {
                  -
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dureeMinutes">
              <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'RAPPORT_PARCOURS.DUREE' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.dureeMinutes != null ? row.dureeMinutes + ' min' : '-' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="certificat">
              <mat-header-cell *matHeaderCellDef>{{ 'RAPPORT_PARCOURS.CERTIFICAT' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let row">
                @if (row.estCertificat) {
                  <mat-icon class="material-symbols-outlined pt-1"
                    [class.hover:cursor-pointer]="row.sessionId"
                    [class.text-green-700]="row.sessionId"
                    [class.dark:text-white]="row.sessionId"
                    [class.text-gray-400]="!row.sessionId"
                  (click)="row.sessionId && telechargerCertificat(row)">file_download</mat-icon>
                } @else {
                  <mat-icon class="material-symbols-outlined text-red-700">toggle_off</mat-icon>
                }
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center py-4 text-gray-400" [attr.colspan]="displayedColumns.length">
                {{ 'CONTENUS_MANAGEMENT.NO_RESULTS' | translate }}
              </td>
            </tr>
          </mat-table>
        </div>
      }

      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" showFirstLastButtons></mat-paginator>
    </div>
  </div>
